<script setup lang="ts">
defineProps<{
    content: string;
    format?: "html" | "plain";
}>();
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-html -- sanitized server-side by AiAssessmentHtmlSanitizer (structural tags only, no attributes) -->
    <div
        v-if="format === 'html'"
        class="ai-assessment-html"
        v-html="content"
    ></div>
    <div v-else class="whitespace-pre-line">{{ content }}</div>
</template>

<style scoped>
.ai-assessment-html :deep(h2),
.ai-assessment-html :deep(h3),
.ai-assessment-html :deep(h4) {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.ai-assessment-html :deep(p) {
    margin-bottom: 0.5rem;
}

.ai-assessment-html :deep(ul) {
    list-style: disc;
    padding-left: 1.25rem;
}

.ai-assessment-html :deep(ol) {
    list-style: decimal;
    padding-left: 1.25rem;
}

.ai-assessment-html :deep(li) {
    margin-bottom: 0.25rem;
}
</style>
